import { Base } from '@app/shared/model';
import { Student, StudentClassesCourse } from '../../admin/model';

export class StudentFeedback extends Base {
  student: Student;
  studentId: number;

  studentClassesCourse: StudentClassesCourse;
  studentClassesCourseId: number;

  feedbackText: string;
  rating: number; // 1 a 10

  constructor(contentResponse: any) {
    super(contentResponse);

    this.feedbackText = contentResponse.feedbackText;
    this.rating = contentResponse.rating;

    this.studentId = parseInt(contentResponse.studentId);
    if (contentResponse && contentResponse.studentId > 0) {
      this.student = contentResponse.student;
    }

    this.studentClassesCourseId = parseInt(
      contentResponse.studentClassesCourseId
    );
    if (contentResponse && contentResponse.studentClassesCourseId > 0) {
      this.student = contentResponse.student;
    }
  }
}
